import { useParams } from 'react-router-dom'
import AccountDetailIndex from './index'
const AccountDetail = () => {
  const { address } = useParams()
  return <AccountDetailIndex key={address} />
}

export default AccountDetail
